export default "__VITE_ASSET__fb5875fb__"